import React from 'react';

import { DetailList } from '@eika-kortbetjening/detail-list';
import { useIsDesktop } from '@eika/hooks/src/useViewType';

import { useAccount } from '@/react-query/hooks/query/use-account';
import { useCard } from '@/react-query/hooks/query/use-card';
import { useCustomer } from '@/react-query/hooks/query/use-customer';

import getDetailListItems from './details';

export const CardDetails = () => {
    const { data: card, isError: cardError } = useCard();
    const accountQuery = useAccount(card);
    const isDesktop = useIsDesktop();
    const customerQuery = useCustomer(card);

    if (!isDesktop) {
        return null;
    }

    if (
        !card ||
        cardError ||
        accountQuery.isPending ||
        customerQuery.isPending ||
        accountQuery.isError ||
        customerQuery.isError
    ) {
        return null;
    }

    return (
        <DetailList header="Detaljer" id="card-information-details">
            {getDetailListItems(card, customerQuery.data, accountQuery.data).map((item) => (
                <DetailList.Item
                    description={item.description}
                    value={item.value}
                    key={item.id || item.value?.toString()}
                />
            ))}
        </DetailList>
    );
};
